export default "__VITE_ASSET__DwDm0d93__"